module.exports = __webpack_public_path__ + "media/32.7c35cfd8.mp3";